import { withApollo } from './apollo';

export default withApollo;
